<template>
  <div class="modal-backdrop d-flex align-items-center justify-content-center">
    <div class="card p-5 mt-5">
      <div class="card-body test">
        <p class="font-weight-bold text-center m-0">
          {{ $t('manage-master-data.company.delete-company', {name: nameCompany}) }}
        </p>
        <p class="font-weight-bold text-danger text-center">
          {{ $t('manage-master-data.company.warning-company') }}
        </p>

        <div class="d-flex justify-content-center mt-5">
          <button
            class="col-sm-4 btn btn-outline-info mx-2"
            @click="$emit('close', 'delete', true)"
          >
            {{ $t('manage-master-data.cancel') }}
          </button>
          <button
            v-if="!isLoadingDelete"
            class="col-sm-4 btn btn-info mx-2"
            @click="deleteCompanies"
          >
            {{ $t('manage-master-data.delete') }}
          </button>
          <button
            v-else
            class="col-sm-4 btn btn-info mx-2"
          >
            <div class="spinner-border spinner-border-sm">
              <span class="sr-only">
                Loading...
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <ModalSuccess
      v-show="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

export default {
  components: {
    ModalSuccess,
    ModalUnsuccessful
  },

  props: {
    idCompany: {
      type: String,
      default: ''
    },
    nameCompany: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    isLoadingDelete: false,
    modal: {
      textModal: '',
      success: false,
      unsuccessful: false
    }
  }),

  methods: {
    async deleteCompanies () {
      this.isLoadingDelete = true
      const data = await Api.companies.delete(this.idCompany)
      if (data.status === 200) {
        this.modal.textModal = this.$t('manage-master-data.company.success-delete', { name: this.nameCompany })
        this.showModal('success')
      } else {
        this.modal.textModal = this.$i18n.locale === 'en' ? data.data.message.messageEng : data.data.message.messageIdn
        this.showModal('unsuccessful')
      }
      this.isLoadingDelete = false
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      this.$emit('close', 'delete', false)
    }
  }
}
</script>

<style scoped>
.card-body {
  max-width: 400px !important;
}
</style>
